<template>
  <div class="top_container">
    <div class="indexTop">
      <div class="left_show">
        <div class="logo">
          <img src="@/assets/images/logo2.png" class="logo1" />
        </div>
        <!--<div class="logo_desc hidden-md-and-down">-->
          <!--<div class="desc1">智众医疗<span>中国慢病管理变革领导者</span></div>-->
          <!--<div class="desc2">致力于用创新模式造福广大慢病患者代谢性疾病心血管疾病</div>-->
        <!--</div>-->
      </div>
      <div class="right_show">
        <el-menu :default-active="activeIndex" mode="horizontal" active-text-color="#0093dd" class="hidden-xs-only">
          <el-menu-item index="/home">
            <router-link to="home">首页</router-link>
          </el-menu-item>
          <el-submenu index="/item">
            <template slot="title">主要项目</template>
            <el-menu-item index="/itemMMC"><router-link to="itemMMC">MMC</router-link></el-menu-item>
            <el-menu-item index="/itemMMCT"><router-link to="itemMMCT">MMC糖网中心</router-link></el-menu-item>
            <el-menu-item index="/itemIHEC"><router-link to="itemIHEC">iHEC</router-link></el-menu-item>
            <el-menu-item index="/itemThreeHeight"><router-link to="itemThreeHeight">三高管理</router-link></el-menu-item>
          </el-submenu>
          <el-submenu index="/life">
            <template slot="title">健康生活</template>
            <el-menu-item index="/life?pro=tnb"><router-link to="life?pro=tnb">糖尿病百科</router-link></el-menu-item>
            <el-menu-item index="/life?pro=gxy"><router-link to="life?pro=gxy">高血压百科</router-link></el-menu-item>
          </el-submenu>
          <el-menu-item index="/about">
            <router-link to="about">关于智众</router-link>
          </el-menu-item>
          <el-menu-item index="/shop">
            <router-link to="shop">网上商城</router-link>
          </el-menu-item>
          <div class="menu_login">
            <el-button round size="mini" @click="$router.push('/login')" v-if="!userName">用户登录</el-button>
            <div v-else>{{userName}}</div>
          </div>
        </el-menu>
        <div class="menu_mobile hidden-sm-and-up">
          <img src="@/assets/images/mobile_menu.png" @click="showNav=!showNav">
          <div class="nav_mobile" v-if="showNav">
            <el-menu :default-active="activeIndex" active-text-color="#0093dd">
              <el-menu-item index="/home">
                <router-link to="home">首页</router-link>
              </el-menu-item>
              <el-submenu index="/item">
                <template slot="title">主要项目</template>
                <el-menu-item index="/itemMMC"><router-link to="itemMMC">MMC</router-link></el-menu-item>
                <el-menu-item index="/itemMMCT"><router-link to="itemMMCT">MMC糖网中心</router-link></el-menu-item>
                <el-menu-item index="/itemIHEC"><router-link to="itemIHEC">iHEC</router-link></el-menu-item>
              </el-submenu>
              <el-submenu index="/life">
                <template slot="title">健康生活</template>
                <el-menu-item index="/life?pro=tnb"><router-link to="life?pro=tnb">糖尿病百科</router-link></el-menu-item>
                <el-menu-item index="/life?pro=gxy"><router-link to="life?pro=gxy">高血压百科</router-link></el-menu-item>
              </el-submenu>
              <el-menu-item index="/about">
                <router-link to="about">关于智众</router-link>
              </el-menu-item>
              <el-menu-item index="/shop">
                <router-link to="shop">网上商城</router-link>
              </el-menu-item>
              <div class="menu_login">
                <el-button round size="mini" @click="$router.push('/login')" v-if="!userName">用户登录</el-button>
                <div v-else>{{userName}}</div>
              </div>
            </el-menu>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="showNav" @click="showNav = false"></div>
  </div>
</template>

<script>
export default {
  name: "indexTop",
  data() {
    return {
      activeIndex: this.$route.path,
      showNav:false,
      userName:this.$store.state.userName
    };
  },
  mounted() {
    const href = window.location.href
    this.activeIndex = href.slice(href.indexOf('#')+1);
  },
  methods: {

  },
  watch:{
    '$route'(){
      this.showNav = false
      const href = window.location.href
      this.activeIndex = href.slice(href.indexOf('#')+1);
    },
    '$store.state.userName'(){
      this.userName = this.$store.state.userName
    }
  }
};
</script>

<style lang="less">
.top_container{
  background-color: #fff;
  border-bottom: 1px solid #dcdcdc;
  .indexTop {
    margin: 0 auto;
    max-width: 1170px;
    height: 59px;
    overflow: hidden;
    .left_show {
      overflow: hidden;
      float: left;
      padding: 8px 0;
      .logo {
        float: left;
        height: 45px;
        img {
          height: 100%;
          vertical-align: middle;
          margin-right: 20px;
        }
      }
      .logo_desc {
        float: left;
        white-space: nowrap;
        font-size: 16px;
        padding-left: 15px;
        border-left: 1px solid #666666;
        .desc1 {
          color: #666666;
          span{
            display: inline-block;
            text-indent: 1em;
          }
        }
        .desc2 {
          font-size: 12px;
          color: #999;
        }
      }
    }
    .right_show {
      float: right;
      white-space: nowrap;
      .menu_mobile{
        display: inline-block;
        height: 60px;
        line-height: 60px;
        img{
          width: 40px;
          height: 30px;
          margin-right: 10px;
        }
        .nav_mobile{
          position: fixed;
          right: 0;
          top: 61px;
          width: 140px;
          z-index: 1000;
          border-left: 1px solid #e6e6e6;
          border-bottom: 1px solid #e6e6e6;
          .el-menu{
            border-right: 0px;
          }
        }
      }
    }
  }
  .mask{
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, .5);
    z-index: 900;
    position: fixed;
  }
}
</style>
